import type { Role } from '@/types/role'
import { isPhoneUserAgent, isPortrait } from './phoneUa'
import { isPublicAuthPath, isSafeInternalPath } from './publicPaths'

export const TALK_PATH = '/talk'
export const LANDSCAPE_PATH_KEY = 'sv.talk.lastLandscapePath'

export const ROLE_DASHBOARD: Record<Role, string> = {
  ultraadmin: '/ultraadmin/dashboard',
  superadmin: '/superadmin/dashboard',
  admin: '/dashboard',
  director: '/director/dashboard',
  hr: '/hr',
  teacher: '/teacher/dashboard',
  engineer: '/messages',
  partner: '/partner/schools',
}

export function isTalkWelt(ua?: string, portrait?: boolean): boolean {
  const agent = ua ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '')
  const port = portrait ?? isPortrait()
  return isPhoneUserAgent(agent) && port
}

export function isPhoneDevice(ua?: string): boolean {
  const agent = ua ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '')
  return isPhoneUserAgent(agent)
}

export function rememberLandscapePath(path: string): void {
  if (typeof sessionStorage === 'undefined') return
  try {
    const pathname = path.split('?')[0] ?? path
    if (!isSafeInternalPath(path)) return
    if (pathname === TALK_PATH) return
    if (isPublicAuthPath(pathname)) return
    sessionStorage.setItem(LANDSCAPE_PATH_KEY, path)
  } catch {
    /* ignore */
  }
}

export function consumeLandscapePath(role: Role | undefined): string {
  const fallback = role ? (ROLE_DASHBOARD[role] || '/dashboard') : '/dashboard'
  if (typeof sessionStorage === 'undefined') return fallback
  const stored = sessionStorage.getItem(LANDSCAPE_PATH_KEY)
  if (!stored || !isSafeInternalPath(stored)) return fallback
  const pathname = stored.split('?')[0] ?? stored
  if (pathname === TALK_PATH || isPublicAuthPath(pathname)) return fallback
  return stored
}

export function talkUiLng(): 'de' | 'en' {
  if (typeof navigator === 'undefined') return 'de'
  return navigator.language.toLowerCase().startsWith('en') ? 'en' : 'de'
}
